import { render, staticRenderFns } from "./headnavdetail.vue?vue&type=template&id=1dea5f19&scoped=true"
import script from "./headnavdetail.vue?vue&type=script&lang=js"
export * from "./headnavdetail.vue?vue&type=script&lang=js"
import style0 from "./headnavdetail.vue?vue&type=style&index=0&id=1dea5f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea5f19",
  null
  
)

export default component.exports